import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import { filter, map } from 'rxjs/operators';

interface BreadcrumbsModel{
  path:string,
  method:string,
  id:string,
  referenceNumber:string
}

@Component({
    selector: 'app-admin-layout',
    templateUrl: './admin-layout.component.html',
    styleUrls: ['./admin-layout.component.scss'],
    standalone: false
})
export class AdminLayoutComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute , private router:Router ) {


    this.router.events.pipe(
        filter(e => e instanceof NavigationEnd),
        map(data => {

          let parsedPath = data['url'].split(/[?/&]+/).filter(data => data != '')

          let value:BreadcrumbsModel = {
            path:parsedPath[0],
            method:parsedPath[1],
            id:parsedPath[2] == undefined ? '' :parsedPath[2].substring(3),
            referenceNumber:parsedPath[3] == undefined ? '' :parsedPath[3].substring(3)
          }
          return value

        })
    ).subscribe(data => {
    })
  }

  ngOnInit() {

  }
}
